
import { ColumnDifference, ColumnBib, ColumnName, ColumnResult, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import { hasConfig } from "components/sports/ows/helper/OwsHelpers"


export function TableColumns() {

    return (
        [
            ColumnBib({ label: 'HeaderBibNo' }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnDifference({}),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })
        ]
    )
}

export function TableColumnsSM() {

    return (
        [
            ColumnBib({ disableSort:true, label: 'HeaderBibNo' }),
            ColumnNoc({}),
            ColumnName({ disableSort:true }),
            ColumnResult({ label: "HeaderTime" }),
            ColumnExpander({ type: hasConfig ? 'alwaysTrue' : 'alwaysTrue' })
        ]
    )
}

export default TableColumns
